//@flow
import React from 'react';
import {makeStyles} from '@material-ui/core';

import CustomTextField from '../../../../../../elements/CustomTextField/CustomTextField';
import FormField from '../../FormField';
import ImageInput from '../../ImageInput';
import {useFormContext} from 'react-hook-form';
import {BLOG_FORM_FIELDS} from '../../../../constants';
import UrlField from './UrlField';
import CategoriesField from './CategoriesField';
import {getImageUrl} from '../../../../../../utils/image_provider';
import {Autocomplete} from '@material-ui/lab';
import {useBlogAuthors} from '../../../../utils/blog-author';
import {
  useCurrentBlogPost,
  useBlogFormDraftValue,
} from '../../../../utils/blog-post';

const useStyles = makeStyles(theme => ({
  formSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
    borderRadius: '.75rem',
    background: 'white',
  },

  featuredPhoto: {
    display: 'flex',
    position: 'relative',
    maxWidth: '600px',
  },
}));

export default function InformationSection() {
  const classes = useStyles();

  const {register, errors, watch, setValue, clearErrors} = useFormContext();
  const currentBlogPost = useCurrentBlogPost();
  const {updateDraft} = useBlogFormDraftValue();

  const authors = useBlogAuthors();

  const posterAlt = watch(BLOG_FORM_FIELDS.posterAlt);
  const watchAuthor = watch(BLOG_FORM_FIELDS.author, '');

  const handleChangeAuthor = (author: string) => {
    setValue(BLOG_FORM_FIELDS.author, author);

    if (author && author.length > 0) {
      clearErrors(BLOG_FORM_FIELDS.author);
    }
  };

  return (
    <section className={classes.formSection}>
      <FormField title="1. Título del articulo">
        <CustomTextField
          placeholder="Título del banner (Max. 40 caracteres incluyendo espacios)"
          fullWidth
          name={BLOG_FORM_FIELDS.title}
          inputRef={register({
            required: 'Este campo es requerido',
          })}
          error={!!errors[BLOG_FORM_FIELDS.title]}
          helperText={
            errors[BLOG_FORM_FIELDS.title] &&
            errors[BLOG_FORM_FIELDS.title].message
          }
          onBlur={e => {
            updateDraft({
              [BLOG_FORM_FIELDS.title]: e.target.value,
            });
          }}
        />
      </FormField>

      <FormField title="2. Nombre del autor">
        <Autocomplete
          options={authors.map(author => author.name)}
          onChange={(event, newValue) => {
            handleChangeAuthor(newValue);
          }}
          onInput={event => {
            const newValue = event.target.value;
            handleChangeAuthor(newValue);
          }}
          value={watchAuthor}
          onBlur={e => {
            updateDraft({
              [BLOG_FORM_FIELDS.author]: e.target.value,
            });
          }}
          renderInput={params => (
            <CustomTextField
              {...params}
              placeholder="Nombre del autor"
              fullWidth
              name={BLOG_FORM_FIELDS.author}
              error={!!errors[BLOG_FORM_FIELDS.author]}
              helperText={
                errors[BLOG_FORM_FIELDS.author] &&
                errors[BLOG_FORM_FIELDS.author].message
              }
            />
          )}
          freeSolo
        />
      </FormField>

      <CategoriesField />
      <UrlField />

      <FormField title="5. Foto destacada">
        <div className={classes.featuredPhoto}>
          <ImageInput
            defaultImage={
              currentBlogPost
                ? getImageUrl(currentBlogPost.mainImageId)
                : undefined
            }
            onChange={image => {
              setValue(BLOG_FORM_FIELDS.poster, image.image);
              setValue(BLOG_FORM_FIELDS.posterAlt, image.alt);
              if (image.image) {
                clearErrors(BLOG_FORM_FIELDS.poster);
              }
            }}
            label={`Sube una imagen (1200 x 800)px`}
            defaultAltText={posterAlt}
            error={!!errors[BLOG_FORM_FIELDS.poster]}
            helperText={
              errors[BLOG_FORM_FIELDS.poster] &&
              errors[BLOG_FORM_FIELDS.poster].message
            }
            aspectRatio={3 / 2}
          />
        </div>
      </FormField>
    </section>
  );
}
